/**
 * 견적서 정보 컴포넌트
 * 계약서의 견적서 정보를 표시하는 컴포넌트입니다.
 * 견적 금액, 견적 내용 등의 정보를 표시합니다.
 */

import { useState } from "react";
import { makeQuotation_TIQ02, patchContract_RCA28 } from "src/api/contract/contract-api";
import { ContractStep, QuotationItemListModel } from "src/api/contract/contract-types";
import { useApiOperation } from "src/api/hooks";
import { ArticleSection } from "src/components/layout/ArticleSection";
import { usePartnerAuthority } from "src/hooks/usePartnerAuthority";
import EstimateDetail from "./detailComponent/EstimateDetail";
import EstimateEdit from "./detailComponent/EstimateEdit";

/**
 * 견적서 정보 컴포넌트의 props 인터페이스
 */
interface BaseProps {
  detailData: any; // 상세 데이터
  viewOnly?: boolean; // 읽기 전용 모드 여부
  setData: Function;
}

/**
 * 견적서 정보 컴포넌트
 * @param detailData 상세 데이터
 * @param viewOnly 읽기 전용 모드 여부
 */
const EstimateInfo = ({ detailData, viewOnly, setData }: BaseProps) => {
  const { isAuthority } = usePartnerAuthority();
  const hasBasicWrite = isAuthority("w", "BASIC");
  const [editable, setEditable] = useState(false);
  const [editConfrim, setEditConfrim] = useState(false);
  const [quotationItemPayload, setQuotationItemPayload] = useState<QuotationItemListModel | null>(null);

  const { executeAsync: makeQuotation } = useApiOperation(makeQuotation_TIQ02);
  const { executeAsync: patchContract } = useApiOperation(patchContract_RCA28);

  const fetchMakeQuotation = async (quotationItemPayload: QuotationItemListModel) => {
    console.log("fetchMakeQuotation", quotationItemPayload);
    const { data } = await makeQuotation({ quotationItemList: [quotationItemPayload] });

    const quotationId = data.data.content.id;
    try {
      await patchContract({
        id: detailData.contract.contractId,
        contract: { contractId: detailData.contract.contractId, quotationList: [{ quotationId: String(quotationId) }] },
      });
      setData();
      setEditable(false);
    } finally {
      setEditConfrim(false);
    }
  };
  const contractStep = detailData?.contract?.contractStep;
  const productType = detailData?.product?.productType;

  // CONTRACT_PLAN이 아닐 때는 disabled가 되도록 disabledState 조작
  // USE_COMPLETE는 DisabledStatesForGeneralProducts에 포함되어 disabled가 됨
  const disabledContractStep = contractStep === ContractStep.CONTRACT_PLAN ? contractStep : ContractStep.USE_COMPLETE;

  const setQuotationItemPayloadHandler = (payload: QuotationItemListModel | null) => {
    setQuotationItemPayload(payload);
  };
  return (
    <ArticleSection
      title={"견적서 정보"}
      isEditable={hasBasicWrite ? editable : undefined}
      setIsEditable={hasBasicWrite ? setEditable : undefined}
      onClickSave={
        hasBasicWrite
          ? () => {
              quotationItemPayload && fetchMakeQuotation(quotationItemPayload);
            }
          : undefined
      }
      saveDisabled={!quotationItemPayload}
      editConfrim={editConfrim}
      setEditConfrim={setEditConfrim}
      disabledState={[String(disabledContractStep), String(productType)]}
      children={
        editable === false ? (
          <EstimateDetail detailData={detailData} viewOnly={viewOnly} />
        ) : (
          <EstimateEdit detailData={detailData} viewOnly={viewOnly} onChangeQuotationItem={setQuotationItemPayloadHandler} />
        )
      }
    />
  );
};
export default EstimateInfo;
